module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "menuBox"
  }, [_c('menu', {
    staticClass: "menu",
    class: _vm.visible ? 'am' : '',
    style: ('top:' + (!_vm.appType ? 57 : 10) + 'px;')
  }, [_c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.value
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      staticClass: "li",
      class: {
        'on skin-color': _vm.tabIndex == index
      },
      on: {
        "click": function($event) {
          _vm.onClick(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-gou fr"
    }), _vm._v("\n                " + _vm._s(item.title) + "\n            ")])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2291b2fe"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c-menuList/c-menuList.vue
// module id = 233
// module chunks = 28